import { createContext, useContext, useReducer } from "react";

export const ButtonSideContext = createContext({});

export const useButtonSideContext = () => {
  return useContext(ButtonSideContext);
};

const reducer = (state, action) => {
  switch (action.type) {
    case "findFiveEarthquake":
      return { ...state, isFiveEarthquake: true, isFeltEarthquake: false };
    case "findFeltEarthquake":
      return { ...state, isFiveEarthquake: false, isFeltEarthquake: true };
    default:
      throw Error(`Unhandled action type: ${action.type}`);
  }
};

const initialState = {
  isFiveEarthquake: false,
  isFeltEarthquake: true,
};

export const ButtonSideContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  const ButtonSideContextValue = [state, dispatch];
  return (
    <ButtonSideContext.Provider value={ButtonSideContextValue}>
      {children}
    </ButtonSideContext.Provider>
  );
};
